//--- ARQUIVO COMPLETO E CORRIGIDO: AppLayout.js (FASE 5 - Adicionando Botão Logout) ---
import React, { useState } from 'react';
// Importa todos os ícones necessários
import { SettingsIcon, HomeIcon, ListIcon, ChartBarIcon, FileTextIcon, SunIcon, MoonIcon, UsersIcon, PackageIcon, MenuIcon, XIcon, WalletIcon, LogOutIcon } from './Icons.js'; // --- [FASE 5] --- LogOutIcon adicionado

// --- [FASE 5] --- Adiciona 'onLogout' aos props
export const AppLayout = ({ children, meiInfo, onSettingsClick, activeView, setActiveView, theme, toggleTheme, onLogout }) => { 
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false); //

    const handleMenuClick = (view) => { //
        setActiveView(view); //
        setIsMobileMenuOpen(false); //
    };

    // Componente reutilizável com o conteúdo da navegação
    const NavContent = () => ( //
        <>
            <div className="relative flex items-center justify-center h-20 px-6 border-b border-gray-700 flex-shrink-0">
                <img src="https://i.imgur.com/xWfURLO.png" alt="Logo MovMei" className="h-16 w-auto" />
                <button
                    onClick={() => setIsMobileMenuOpen(false)}
                    className="absolute top-4 right-4 p-2 text-gray-400 hover:text-white md:hidden"
                >
                    <XIcon /> {/* */}
                </button>
            </div>
            <nav className="flex-1 px-4 py-6 space-y-2 overflow-y-auto"> {/* */}
                <button onClick={() => handleMenuClick('dashboard')} className={`w-full flex items-center px-4 py-2 rounded-md text-left transition-colors ${activeView === 'dashboard' ? 'bg-blue-600 text-white' : 'text-gray-400 hover:bg-gray-700 hover:text-white'}`}><HomeIcon /><span className="ml-3">Visão Geral</span></button> {/* */}
                <button onClick={() => handleMenuClick('transactions')} className={`w-full flex items-center px-4 py-2 rounded-md text-left transition-colors ${activeView === 'transactions' ? 'bg-blue-600 text-white' : 'text-gray-400 hover:bg-gray-700 hover:text-white'}`}><ListIcon /><span className="ml-3">Lançamentos</span></button> {/* */}
                <button onClick={() => handleMenuClick('budgets')} className={`w-full flex items-center px-4 py-2 rounded-md text-left transition-colors ${activeView === 'budgets' ? 'bg-blue-600 text-white' : 'text-gray-400 hover:bg-gray-700 hover:text-white'}`}><FileTextIcon /><span className="ml-3">Orçamentos</span></button> {/* */}
                <button onClick={() => handleMenuClick('clients')} className={`w-full flex items-center px-4 py-2 rounded-md text-left transition-colors ${activeView === 'clients' ? 'bg-blue-600 text-white' : 'text-gray-400 hover:bg-gray-700 hover:text-white'}`}><UsersIcon /><span className="ml-3">Clientes</span></button> {/* */}
                <button onClick={() => handleMenuClick('products')} className={`w-full flex items-center px-4 py-2 rounded-md text-left transition-colors ${activeView === 'products' ? 'bg-blue-600 text-white' : 'text-gray-400 hover:bg-gray-700 hover:text-white'}`}><PackageIcon /><span className="ml-3">Produtos & Serviços</span></button> {/* */}
                <button onClick={() => handleMenuClick('accounts')} className={`w-full flex items-center px-4 py-2 rounded-md text-left transition-colors ${activeView === 'accounts' ? 'bg-blue-600 text-white' : 'text-gray-400 hover:bg-gray-700 hover:text-white'}`}><WalletIcon /><span className="ml-3">Contas</span></button>
                <button onClick={() => handleMenuClick('reports')} className={`w-full flex items-center px-4 py-2 rounded-md text-left transition-colors ${activeView === 'reports' ? 'bg-blue-600 text-white' : 'text-gray-400 hover:bg-gray-700 hover:text-white'}`}><ChartBarIcon /><span className="ml-3">Relatórios</span></button> {/* */}
                <button onClick={() => handleMenuClick('das')} className={`w-full flex items-center px-4 py-2 rounded-md text-left transition-colors ${activeView === 'das' ? 'bg-blue-600 text-white' : 'text-gray-400 hover:bg-gray-700 hover:text-white'}`}><FileTextIcon /><span className="ml-3">Impostos (DAS)</span></button> {/* */}
            </nav>
        </>
    );

    return (
        <div className="flex h-screen bg-gray-100 dark:bg-gray-900 overflow-hidden"> {/* */}
            <aside className="w-64 bg-gray-800 text-white flex flex-col hidden md:flex shadow-lg"> {/* */}
                <NavContent />
            </aside>

            {/* Menu Mobile */}
            {isMobileMenuOpen && ( //
                <div className="fixed inset-0 flex z-40 md:hidden"> {/* */}
                    <div className="fixed inset-0 bg-black opacity-50" onClick={() => setIsMobileMenuOpen(false)}></div> {/* */}
                    <div className="relative flex-1 flex flex-col max-w-xs w-full bg-gray-800 text-white"> {/* */}
                        <NavContent />
                    </div>
                </div>
            )}

            <div className="flex-1 flex flex-col overflow-hidden"> {/* */}
                <header className="bg-white dark:bg-gray-800 shadow-sm z-10 flex-shrink-0"> {/* */}
                    <div className="max-w-full mx-auto py-4 px-4 sm:px-6 lg:px-8 flex justify-between items-center"> {/* */}
                        <button onClick={() => setIsMobileMenuOpen(true)} className="md:hidden p-2 -ml-2 text-gray-500 dark:text-gray-400"> {/* */}
                            <MenuIcon /> {/* */}
                        </button>
                        <div className="flex-1 text-center md:text-left min-w-0"> {/* */}
                            <h1 className="text-xl font-bold text-gray-900 dark:text-gray-200 truncate">{meiInfo?.nome || 'Carregando...'}</h1> {/* */}
                            <p className="text-sm text-gray-500 dark:text-gray-400 hidden md:block truncate">CNPJ: {meiInfo?.cnpj || '...'}</p> {/* */}
                        </div>
                        
                        {/* --- [FASE 5] --- Botões da Direita (Tema, Config, Logout) --- */}
                        <div className="flex items-center space-x-2 flex-shrink-0"> {/* */}
                            <button 
                                onClick={toggleTheme} 
                                title={theme === 'dark' ? "Modo Claro" : "Modo Escuro"}
                                className="p-2 rounded-full text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700"> {/* */}
                               {theme === 'dark' ? <SunIcon /> : <MoonIcon />} {/* */}
                            </button>
                            <button 
                                onClick={onSettingsClick} 
                                title="Configurações"
                                className="p-2 rounded-full text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700">
                                <SettingsIcon />
                            </button> {/* */}
                             <button 
                                onClick={onLogout} 
                                title="Sair"
                                className="p-2 rounded-full text-red-500 dark:text-red-400 hover:bg-red-100 dark:hover:bg-red-700/50">
                                <LogOutIcon />
                            </button>
                        </div>
                         {/* --- FIM DA ALTERAÇÃO --- */}

                    </div>
                </header>
                <main className="flex-1 overflow-y-auto bg-gray-50 dark:bg-gray-900 p-4 sm:p-6"> {/* */}
                    {children} {/* */}
                </main>
            </div>
        </div>
    );
};